import type { Carrier } from "@babackapp/private-api-client/types";

export function CarrierName({ carrier }: { carrier: Carrier }) {
  return <span>{carrier.title || carrier.code}</span>;
}
